class PendingEnquiryController {
  constructor(authService, pushService, messagingService, $interval, $timeout, $scope, contactService, enums) {
    "ngInject";

    this.authService = authService;
    this.pushService = pushService;
    this.messagingService = messagingService;
    this.$interval = $interval;
    this.$timeout = $timeout;
    this.$scope = $scope;
    this.contactService = contactService;
    this.enums = enums;

    this.pushService.registerEnquiryDeclinedHandler(this.enquiryDeclined.bind(this));
    this.pushService.registerEnquiryAcceptedHandler(this.enquiryAccepted.bind(this));
    this.pushService.registerEnquiryHeldHandler(this.enquiryHeld.bind(this));
    this.sendMessage();

    $scope.$on('welcomeCentre:ownerUpdated', this.ownerUpdated.bind(this));
  }

  sendMessage() {
    this.status = 'Awaiting Response';
    const ctrl = this;

    //Create an Inbox Message
    const msg = this.getMessageBody();

    ctrl.messagingService.addMessage(msg)
      .then((response) => {
        if (!this.enquiry.isExisting) {
          ctrl.pushService.messageHub.enquiryCreated(ctrl.enquiry.enquiryId, ctrl.enquiry.ownerId, ctrl.authService.authData.userId);
        }
        else {
          ctrl.pushService.messageHub.existingEnquiry(ctrl.enquiry.enquiryId, ctrl.enquiry.ownerId, ctrl.authService.authData.userId, ctrl.enquiry.contactName, ctrl.enquiry.contactMethod);
        }
        ctrl.confirmationTimeout();
      });
  }

  getMessageBody() {
    const ctrl = this;

    let msg = {
      senderId: ctrl.authService.authData.userId,
      userId: ctrl.enquiry.ownerId,
      body: JSON.stringify({
        enquiryId: ctrl.enquiry.enquiryId
      })
    };

    if (!this.enquiry.isExisting) {
      msg.subject = "New Enquiry Created";
    }
    else {
      switch(this.enquiry.contactMethod) {
        case this.enums.ENQUIRY_ORIGINATION.WalkIn:
          msg.subject = "Customer waiting at reception";
          break;

        case this.enums.ENQUIRY_ORIGINATION.Phone:
          msg.subject = "Customer is on the phone looking to speak to you";
          break;
          
        case this.enums.ENQUIRY_ORIGINATION.Email:
          msg.subject = "Customer has sent an email and is looking for you to contact them";
          break;
          
        case this.enums.ENQUIRY_ORIGINATION.Web:          
          msg.subject = "Customer has sent a message through the web and is looking for you to contact them";          
          break;
      }      
    }

    return msg;
  }

  confirmationTimeout(timeoutVal) {
    const ctrl = this;

    ctrl.remainingTime = timeoutVal || 30;

    ctrl.intervalId = ctrl.$interval(() => {
      ctrl.remainingTime--;
    }, 1000, ctrl.remainingTime);
  }

  enquiryDeclined(enquiryId) {
    if (enquiryId === this.enquiry.enquiryId) {
      this.$interval.cancel(this.intervalId);
      this.$scope.$apply(() => {
        this.status = 'Rejected';
        this.remainingTime = 0;
      });
    }
  }

  ownerUpdated(evt, params) {
    if (params.enquiryId === this.enquiry.enquiryId) {
      this.sendMessage();
    }
  }

  enquiryAccepted(enquiryId) {
    if (enquiryId === this.enquiry.enquiryId) {
      this.$interval.cancel(this.intervalId);

      this.$scope.$apply(() => {
        this.remainingTime = 0;

        /*
        * This looks like a hack for a memory leak in angular
        * manually set the enquiry id to 0 so that it does
        * not come in this condition at all
        */
        this.enquiry.enquiryId = 0;

        this.$interval(() => {
          //Add Life Cycle Event if Existing enquiryId
          if (this.enquiry.isExisting) {
            this.contactService.addEvent(this.enquiry.contactId, this.enquiry.contactMethod, this.enquiry.ownerId, enquiryId);
          }

          this.onAccepted({enquiryId: this.enquiry.enquiryId});
        }, 1000, 1);
      });
    }
  }

  enquiryHeld(enquiryId) {
    if (enquiryId === this.enquiry.enquiryId) {
      this.$interval.cancel(this.intervalId);
      this.$scope.$apply(() => {
        this.status = 'Held';
        this.remainingTime = 0;

        /*
        * This looks like a hack for a memory leak in angular
        * manually set the enquiry id to 0 so that it does
        * not come in this condition at all
        */
        this.enquiry.enquiryId = 0;

        let locationHoldTime = this.authService.authData.currentLocation.enquiryHoldTime;
        if (!locationHoldTime) {
          locationHoldTime = 5;
        }

        //Add Life Cycle Event if Existing enquiryId
        if (this.enquiry.isExisting) {
          this.contactService.addEvent(this.enquiry.contactId, this.enquiry.contactMethod, this.enquiry.ownerId, enquiryId);
        }

        this.confirmationTimeout(locationHoldTime * 60);
      });
    }
  }
}

export default PendingEnquiryController;



// WEBPACK FOOTER //
// ./client/app/components/welcomeCentre/pendingEnquiry/pendingEnquiry.controller.js